import $ from "jquery";

// акцент на производительность
// в теории должно быть аналогом $div.is(":visible")
// вариант ниже быстрее в несколько 1000 раз
$.fn.isVisible = function() {
    let div = this[0];
    if ( !div ) {
        return false;
    }

    // обращение к offsetWidth/Height вызывает пересчет древа DOM
    if ( div.style.display == "none" ) {
        return false;
    }

    return div.offsetHeight || div.offsetWidth;
};
